import { Box, CircularProgress } from '@mui/material'

interface LoaderProps {
  fullScreen?: boolean
}

export const Loader = ({ fullScreen = false }: LoaderProps) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      minHeight: fullScreen ? '100vh' : 240,
    }}
  >
    <CircularProgress />
  </Box>
)
